'use strict';

(function () {
	if (!customElements.get('multi-scroll-gallery')) {

		const centerStickyWrapper = (height, stickyWrapper) => {


			const availableHeight = Math.max(window.innerHeight - height, 0);
			const topOffset = Math.max(availableHeight / 2, 0);
			stickyWrapper.style.top = topOffset + 'px';
			return topOffset;
		};
		class MultiScrollGalllery extends HTMLElement {
			constructor() {
				super();
				this.activeItem = 0;
				this.horizontalSection = this.querySelector('.multi-scroll-gallery__horizontal-section');
				this.stickyWrapper = this.querySelector('.multi-scroll-gallery__sticky-wrapper');
				this.imgWrapper = this.querySelector('.multi-scroll-gallery__right');
				this.contentWrapper = this.querySelector('.multi-scroll-gallery__left');
				this.contentItems = this.querySelectorAll('.multi-scroll-gallery__item');
				this.images = this.querySelectorAll('.multi-scroll-gallery__right .multi-scroll-gallery__image-wrapper');
			}

			connectedCallback() {
				if (this.contentItems.length < 2) {
					return
				}

				this.initScroll();

				window.addEventListener('resize', () => {
					this.initScroll.call(this);
				});
			}
		}
	

		MultiScrollGalllery.prototype.initScroll = function() {
			const imageHeight = this.images[0].offsetHeight;
			const topOffset = centerStickyWrapper(imageHeight, this.stickyWrapper);
			const scrollDistance = imageHeight * this.images.length;
			if (window.innerWidth >= 1200) {
				this.horizontalSection.style.height = `${scrollDistance + topOffset}px`;
				this.imgWrapper.style.maxHeight = `${imageHeight}px`;
				this.contentWrapper.style.maxHeight = `${imageHeight}px`;
				this.stickyWrapper.style.maxHeight = `${imageHeight}px`;
			} else {
				this.horizontalSection.style.height = `auto`;
				this.imgWrapper.style.maxHeight = `100%`;
				this.contentWrapper.style.maxHeight = `100%`;
				this.stickyWrapper.style.maxHeight = `100%`;
				this.imgWrapper.style.transform = `translateY(0)`;
			}
			
			const onScroll = () => {
				if (window.innerWidth >= 1200) {
					const scrollTop = window.pageYOffset;
					const distFromTop = this.horizontalSection.getBoundingClientRect().top + window.pageYOffset;
					const scrollPosition = Math.max(0, Math.min(scrollTop - distFromTop, scrollDistance - imageHeight));
					this.imgWrapper.style.transform = `translateY(-${scrollPosition}px)`;

					// add active class to current item
					this.images.forEach((image, index) => {
						if (image.offsetTop <= scrollPosition && scrollPosition < ( image.offsetTop + imageHeight)) {
							this.activeItem = index;
								
							this.contentItems.forEach((item, index, arr) => {
								item.classList.remove('active');
								item.classList.remove('prev-item');
								if(index == this.activeItem) {
									item.classList.add('active');
								}
								if (index != 0 && index == this.activeItem) {
									arr[index - 1].classList.add('prev-item')
								}
							});
						}
					})
				}
			};

			const optimizedScroll = () => {
				requestAnimationFrame(onScroll);
			};
	
			window.addEventListener('scroll', optimizedScroll);
			optimizedScroll();
		};

		customElements.define('multi-scroll-gallery', MultiScrollGalllery);
	}
	
})();